import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  imports: [CommonModule],
})
export class PageNotFoundComponent {
  constructor() {}

  goToHome() {
    window.location.href = 'https://hey-kiddo.com';
  }
}
